module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Minus-08ddf483346883d63609abe3cdb36ab3.svg";